export const yearsOfExperience = [
  {},
  { label: 'Under 2 years', value: 'Under 2 years' },
  { label: '2-5 Years', value: '2-5 Years' },
  { label: '6-10 Years', value: '6-10 Years' },
  { label: '11+ Years', value: '11+ Years' }
]
